// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./src/scss/theme.scss");
var __webpack_exports__ = __webpack_require__("./src/js/theme.ts");
